import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../../actions/authActions';
import * as sessionActions from '../../actions/sessionActions';

import { authSelector, sessionSelector } from '../../selectors';

class LogoutPage extends Component {
	componentDidMount() {
		const { session } = this.props;
		this.logoutUser = this.logoutUser.bind(this);
		if (session.authenticated) {
			this.logoutUser();
		}
	}
	componentDidUpdate() {
		const { session, auth } = this.props;
		if (!session.authenticated && !auth.authenticated && !session.requiresLogin) {
			window.location = '/';
		}
	}
	async logoutUser() {
		const { actions } = this.props;
		actions.logOutUser();
	}
	render() {
		return <div></div>;
	}
}

LogoutPage.propTypes = {
	auth: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
	return {
		auth: authSelector(state),
		session: sessionSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {
		actions: {
			...bindActionCreators(authActions, dispatch),
			...bindActionCreators(sessionActions, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);
